/**
 * Fields on the standard overview that are not yet backed by API data.
 * Remove entries as real endpoints / project fields are wired.
 */
export const OVERVIEW_DUMMY_FIELDS = {
    /** Subtitle under observation count when observations exist (no API field). */
    observationsStageLabel: 'StandardOverview / ObservationsCard — "Early project stage"',

    /** RAID "high priority" count uses impact === "High" heuristic; confirm with product. */
    raidHighPriorityCount: 'StandardOverview / DeliveryGovernanceCard — high priority RAID rows',

    /** Intelligence card "needs review" badge when insights API reports pending modules. */
    intelligenceNeedsReviewBadge: 'StandardOverview / IntelligenceInsightsCard — derived from insights overview API',

    /** Source materials list when project has no source_materials / context_documents on project payload. */
    sourceMaterialsFallback: 'StandardOverview / SourceMaterialsCard — project.source_materials from initial ProjectFile uploads',

    /** All IRL card counts/copy when using ?overviewIrlPreview= (see standardOverviewIrl.js fixtures). */
    irlOverviewPreviewFixtures: 'utils/standardOverviewIrl.js — IRL_OVERVIEW_PREVIEW_FIXTURES',

    /** Recent Project Activity rows on findings-ready overview (no activity feed API yet). */
    recentProjectActivity: 'StandardOverview / RecentProjectActivityCard — RECENT_ACTIVITY_PREVIEW',

    /** Mature overview (6849:6400 / 6849:7411) when using ?overviewMaturity=attention|healthy. */
    overviewMaturityFixtures: 'utils/standardOverviewMaturity.js — MATURITY_FIXTURES (until overview_maturity API)',

    /** PMI/VDD operational mini-row duplicates delivery stats (same Redux data as DeliveryGovernanceCard). */
    operationalMiniCards: 'OperationalOverviewRow — buildOperationalSummaries from delivery + observations',
};
